import type { ObjectValues } from "@/src/shared/types/objectValues";

// jQuery masks script types while inserting HTML and can leave nested custom-element
// transport scripts masked after their parent captures the server-rendered content.
export const SCRIPT_PROP_SELECTOR =
  ':scope > script:is([type="application/json"], [type="true/application/json"])[data-prop]' as const;
export const EASY_CUSTOM_ELEMENTS_PREFIX = "easy8" as const;
export const SCRIPT_PROPS_KEY = "_scriptProps" as const;
/** Marks the placeholder rendered when a lazy registry component fails to load. */
export const CUSTOM_ELEMENT_LOAD_ERROR_ATTR = "data-easy8-custom-element-load-error" as const;

/** Short custom-element names for non-DS (business-level) components. */
export const CUSTOM_ELEMENT_NAME = {
  ActionMenu: "action-menu",
  Autocomplete: "autocomplete",
  TranslatableTextField: "translatable-text-field",
  FeatureHint: "feature-hint",
} as const;

export type CustomElementName = ObjectValues<typeof CUSTOM_ELEMENT_NAME>;

/** Build the full custom-element tag name, e.g. `easy8-ds-icon` or `easy8-autocomplete`. */
// eslint-disable-next-line easy-rules/naming-convention -- utility function, not a constant
export const customElementTag = <T extends string>(name: T): `${typeof EASY_CUSTOM_ELEMENTS_PREFIX}-${T}` =>
  `${EASY_CUSTOM_ELEMENTS_PREFIX}-${name}`;
